import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import CurrentPaymentMethod from './CurrentPaymentMethod';
import AutopayIcon from './AutopayIcon';
import SubBox from 'common/SubBox';
import { unpaidPurchase } from 'app/routes';
import MergePurchasesModal from './MergePurchasesModal';
import { fetchMergePurchasePrice as fetchMergePurchasePriceApi } from '../purchases/api';

import styles from './CurrentDue.module.css';
class OverdueAndUpcomingBill extends Component {
  state = {
    isOpen: false,
    priceObj: {}
  }

  wasPriceFetch = false;

  componentDidMount() {
    const { overduePurchases } = this.props;
    this.fetchMergePurchasePrice(overduePurchases);
  }

  handleOpenModal = (e) => {
    const purchases = this.purchases;
    const purchasesWithOrders = purchases.filter(purchase => purchase.orders.length !== 0);

    // only purchases with orders available
    if (purchasesWithOrders.length === purchases.length) {
      this.props.dispatch(unpaidPurchase(purchases[0].id));
      return;
    }

    this.openModal(e);
  }

  openModal = (e) => {
    e.preventDefault();
    this.setState({ isOpen: true });
  }

  closeModal = () => {
    this.setState({ isOpen: false });
  }

  // purchases with orders can't be merged
  filterOutPurchaseWithOrdersAndZeroPrice = (purchases) => {
    return purchases.filter(purchase => {
      const amount = purchase.cost && purchase.cost.amount;
      return parseFloat(amount) !== 0 && purchase.orders.length === 0
    })
  }

  fetchMergePurchasePrice = (purchases) => {
    this.wasPriceFetch = true;
    if (purchases.length > 1) {
      fetchMergePurchasePriceApi({ ids: this.filterOutPurchaseWithOrdersAndZeroPrice(purchases).map(p => p.id) })
        .then(response => {
          const priceObj = response.data;
          this.setState({
            priceObj,
          });
        })
        .catch(e => {
          this.setState({
            priceErr: (e.response && e.response.data) || true,
          });
        });
    } else if (purchases.length === 1) {
      this.setState({
        priceObj: purchases[0].cost,
      });
    }
  }

  render() {
    const {
      paymentMethod,
      user,
      overduePurchases,
    } = this.props;
    const { isOpen, priceObj, priceErr } = this.state;
    const isPastDue = overduePurchases.every(purchase => purchase.status === 'arranged');
    const purchases = [...overduePurchases];

    let renewalTotal = 0;
    const isOverduePurchases = overduePurchases.length !== 0;
    const isRenewPurchase = renewalTotal > 0;
    this.purchases = purchases;

    return (
      <React.Fragment>
        <div className={styles.totalsWrapper}>
          <div>
            {isOverduePurchases && priceObj.total && (
              <div>
                <span className={cn(styles.totalDue, styles.overdue)}>
                  ${priceObj.total}
                </span>
                {' '}
                <span className={styles.dueDate}>
                  {isPastDue ? 'past due' : 'due today'}
                </span>
              </div>
            )}
            { isRenewPurchase && (
              <div>
                <span className={cn(styles.totalDue, styles.overdue)}>
                  ${Number(renewalTotal).toFixed(2)}
                </span>
                {' '}
                <span className={styles.dueDate}>
                  next cycle
                </span>
              </div>
            )}
          </div>
          <CurrentPaymentMethod paymentMethod={paymentMethod} />
        </div>
        <SubBox>
          <AutopayIcon enabled={user.autopay_enabled} />
          <button onClick={this.handleOpenModal} className={styles.payNow}>
            { isRenewPurchase && isOverduePurchases ? 'Pay All' : 'View Bill' }
          </button>
        </SubBox>
        <MergePurchasesModal
          isOpen={isOpen}
          purchases={this.filterOutPurchaseWithOrdersAndZeroPrice(purchases)}
          closeModal={this.closeModal}
          isRenewPurchase={isRenewPurchase}
          priceObj={priceObj}
          outerPriceErr={priceErr}
        />
      </React.Fragment>
    );
  }
}

export default connect()(OverdueAndUpcomingBill);
